"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var VideoLibrary = function VideoLibrary(_ref) {
  var size = _ref.size,
      color = _ref.color;
  var iconSize = size === 'original' ? 'width="48" height="48"' : 'width="100%"';
  var title = 'Video Library Icon';
  return "\n    <svg role=\"img\" aria-label=\"".concat(title, "\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" ").concat(iconSize, " viewBox=\"0 0 48 48\">\n      <title>").concat(title, "</title>\n      <path fill=").concat(color, " d=\"M21.25 29.15 34.7 20.5l-13.45-8.65Zm-7.5 9.1q-1.65 0-2.825-1.175Q9.75 35.9 9.75 34.25V6.75q0-1.6 1.175-2.775Q12.1 2.8 13.75 2.8h27.5q1.6 0 2.775 1.175Q45.2 5.15 45.2 6.75v27.5q0 1.65-1.175 2.825-1.175 1.175-2.775 1.175Zm-7 6.95q-1.6 0-2.775-1.175Q2.8 42.85 2.8 41.25V9.75h3.95v31.5h31.5v3.95Z\"/>\n    </svg>\n  ");
};

var _default = VideoLibrary;
exports["default"] = _default;